import request from '@/utils/request';
import Resource from '@/api/resource';
class AdvertisingResource extends Resource {
  constructor() {
    super('advertising');
  }

  // 获取游戏列表接口
  getGameListApi(data) {
    return request({
      url: '/game',
      method: 'get',
      params: data,
    });
  }

  /** 获取落地页接口 */
  getAllPageList(data) {
    return request({
      url: '/tool/site/jrtt',
      method: 'get',
      params: data,
    });
  }

  /** 同步落地页接口 */
  pullAllPageList(data) {
    return request({
      url: '/tool/site/jrtt/pull',
      method: 'get',
      params: data,
    });
  }

  /** 获取转化ID列表接口 */
  getAllConvertList(data) {
    data.more = true;
    return request({
      url: '/tool/convert/jrtt',
      method: 'get',
      params: data,
    });
  }

  /** 获取行业列表接口 */
  getAllIndustryList(data) {
    return request({
      url: '/tool/industry/jrtt',
      method: 'get',
      params: data,
    });
  }
  /** 同步行业列表接口 */
  syncIndustry(data) {
    return request({
      url: '/tool/industry/jrtt/pull',
      method: 'get',
      params: data,
    });
  }
  /** 同步词包列表接口 */
  syncCreativeWord(data) {
    return request({
      url: '/tool/creativeWord/jrtt/pull',
      method: 'get',
      params: data,
    });
  }
  /** 同步转化列表接口 */
  syncConvert(data) {
    return request({
      url: '/tool/convert/jrtt/pull',
      method: 'get',
    });
  }
  /** 获取动态词语包 */
  getAllWord() {
    return request({
      url: '/tool/creativeWord/jrtt',
      method: 'get',
    });
  }

  /** 新建计划接口 */
  creatPlanApi(data) {
    return request({
      url: '/plan/jrtt',
      method: 'POST',
      data,
    });
  }

  /** 修改广告组接口 */
  setCampaignInfo(data) {
    return request({
      url: '/adgroup/jrtt/updateCampaign',
      method: 'POST',
      data,
    });
  }

  /** 获取计划接口 */
  getPlanInfo(id) {
    return request({
      url: `/plan/jrtt/${id}`,
      method: 'GET',
    });
  }

  /** 修改计划接口 */
  setPlanInfo(data, id) {
    return request({
      url: `/plan/jrtt/updatePlan/${id}`,
      method: 'POST',
      data,
    });
  }
  /** 获取行动号召接口 */
  getAction() {
    return request({
      url: '/tool/actionText/jrtt',
      method: 'get',
    });
  }
  /** 获取广告主绑定的抖音号接口 */
  getTikTokAccountApi(data) {
    return request({
      url: '/tool/douyin/jrtt/accountSearch',
      method: 'get',
      params: data,
    });
  }
  /** 获取地域列表 */
  getRegionListApi(data) {
    return request({
      url: '/tool/region/jrtt',
      method: 'get',
      params: data,
    });
  }
  // 批量新建计划
  creatBatchPlanApi(data) {
    return request({
      url: '/plan/jrtt/batch',
      method: 'post',
      data,
    });
  }
}
export { AdvertisingResource as default };
